<template>
    <div
        class="modal fade"
        :class="{ 'ds-modal': isDsModal, 'ds-modal--narrow': isDsModalNarrow }"
        role="dialog"
        ref="modalRef"
        :data-backdrop="backdropStatic ? 'static' : null"
    >
        <div
            class="modal-dialog"
            :class="[
                verticallyCentered ? 'modal-dialog-centered' : '',
                isDsDialog ? 'ds-dialog' : '',
                isDsDialogNarrow ? 'ds-dialog--narrow' : '',
            ]"
        >
            <div class="modal-content">
                <button v-if="closeButton" type="button" class="btn-close" data-dismiss="modal" @click="hide">
                    Zavřít
                </button>
                <div class="modal-body">
                    <slot></slot>
                </div>
                <slot name="afterBody"></slot>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref, watchEffect } from "vue";

export default defineComponent({
    name: "ModalPopup",
    props: {
        modelValue: {
            type: Boolean,
            required: true,
            default: false,
        },
        verticallyCentered: Boolean,
        isDsModal: Boolean,
        isDsDialog: Boolean,
        isDsModalNarrow: Boolean,
        isDsDialogNarrow: Boolean,
        closeButton: { type: Boolean, default: true },
        backdropStatic: { type: Boolean, default: false },
    },
    emits: ["update:modelValue", "close"],
    setup(props, { emit }) {
        const modalRef = ref<HTMLElement | null>(null);

        const show = () => {
            $(modalRef.value).modal("show");
            $(modalRef.value).modal("handleUpdate");
        };

        const hide = () => {
            $(modalRef.value).modal("hide");
        };

        onMounted(() => {
            $(modalRef.value).on("shown.bs.modal", () => {
                emit("update:modelValue", true);
                $(modalRef.value).modal("handleUpdate");
            });

            $(modalRef.value).on("hidden.bs.modal", () => {
                // modal was closed by clicking on 'close' button or clicking on backdrop (if modal is closed externally, modelValue is already set to false)
                if (props.modelValue) {
                    emit("close");
                }

                emit("update:modelValue", false);
            });
        });

        watchEffect(() => {
            if (props.modelValue) {
                show();
            } else {
                hide();
            }
        });

        return {
            modalRef,
            hide,
        };
    },
});
</script>
